export const stripHtml = str => str.replace(/<\/?[^>]+(>|$)/g, '');
export const serializeMessage = message => {
  const baseMessage = message.value;
  if (message.displayType === 'SECTIONS') {
    return message.sections.reduce((acc, section) => {
      if (section.type === 'HTML' || section.type === 'LLM' || section.type === 'PLAIN_TEXT') {
        if (acc) {
          acc += '\n\n';
        }
        acc += stripHtml(section.text || '');
      }
      return acc;
    }, '');
  }
  return stripHtml(baseMessage || '');
};